import React from "react";
import { ScriptsGrid } from "../components";

const HtmlPageSkins = () => {
  return <ScriptsGrid isHTML />;
};

export default HtmlPageSkins;
